// about-content 背景画像変更
window.addEventListener('DOMContentLoaded', initializeBackgroundImage);
window.addEventListener('resize', changeBackgroundImage);
window.addEventListener('scroll', changeBackgroundImage);

function initializeBackgroundImage() {
  var backgroundImage = document.querySelector('.background-image');
  if (backgroundImage) {
    backgroundImage.style.transition = 'opacity 2s';
    backgroundImage.style.display = 'block';
    backgroundImage.style.opacity = '0';
  } else {
    console.warn('背景画像が見つかりませんでした。');
  }
}

function changeBackgroundImage() {
  var target = document.documentElement.scrollHeight / 2;
  var current = window.pageYOffset + (window.innerHeight * 0.5);
  if (document.getElementById('about-content')) {
    var backgroundImage = document.querySelector('.background-image');
    if (target < current) {
      backgroundImage.style.opacity = '1';
    } else {
      backgroundImage.style.opacity = '0';
    }
  }
}

// loading設定
window.addEventListener('DOMContentLoaded', (event) => {
  // about-content ページ専用
  if (document.getElementById('about-content')) {
    document.querySelector('.title.onload').classList.add('onload-active');
    document.querySelector('.copy.onload').classList.add('onload-active');
    document.querySelector('.text-wrap.onload').classList.add('onload-active');
  }
});

window.addEventListener('DOMContentLoaded', (event) => {
  // about-top ページ専用
  if (document.getElementById('about-top')) {
    document.querySelector('.title.onload').classList.add('onload-active');
    document.querySelector('.copy.onload').classList.add('onload-active');
    document.querySelector('.text-wrap.onload').classList.add('onload-active');
  }
});



// モーダル
document.addEventListener('DOMContentLoaded', (event) => {
  const customModal = document.querySelector('.js-modal');
  const openBtn = document.querySelector('.js-modal-trigger');
  const closeBtn = document.querySelector('.js-modal-close');
  const modalBg = document.querySelector('.js-modal-bg');

  openBtn.addEventListener('click', () => {
    customModal.classList.add('is-open');
    modalBg.classList.add('is-open');
  });

  closeBtn.addEventListener('click', () => {
    customModal.classList.remove('is-open');
    modalBg.classList.remove('is-open');
  });

  modalBg.addEventListener('click', () => {
    customModal.classList.remove('is-open');
    modalBg.classList.remove('is-open');
  });

  // Escapeキーでモーダルを閉じる
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && customModal.classList.contains('is-open')) {
      customModal.classList.remove('is-open');
      modalBg.classList.remove('is-open');
    }
  });
});



// 表示判定
window.addEventListener('DOMContentLoaded', checkVisibility);
window.addEventListener('scroll', checkVisibility);
window.addEventListener('resize', checkVisibility);

function checkVisibility() {
  // 表示判定（区間）
  document.querySelectorAll('.inview-repeat').forEach(function(element){
    var targetStart = element.offsetTop;
    var targetEnd = targetStart + element.offsetHeight;
    var current = window.pageYOffset + (window.innerHeight * 0.5);
    if ((targetStart < current) && (current < targetEnd)) {
      element.classList.add('inview-repeat-active');
    }
    if ((targetEnd + window.innerHeight) < current) {
      element.classList.remove('inview-repeat-active');
    }
    if ((window.pageYOffset + window.innerHeight) < targetStart) {
      element.classList.remove('inview-repeat-active');
    }
  });

  // 表示判定（1回のみ）
  document.querySelectorAll('.inview').forEach(function(element){
    var targetStart = element.offsetTop;
    var current = window.pageYOffset + (window.innerHeight * 0.8);
    if (targetStart < current) {
      element.classList.add('inview-active');
    }
  });
}

(function ($, window) {
  "use strict";
  var bp = 736;

  // about-top 高さ指定 pc限定
  $(window).on('load resize', function() {
    if ($('#about-top').length){
      if (bp < $(window).width()) {
        var contentHeight = $(window).height();
        var contentMaxHeight = 0;
        if (1200 < $(window).width()) {
          contentMaxHeight = $(window).width() * 0.8;
        } else {
          contentMaxHeight = 1200 * 0.8;
        }
        //var contentHeight = $(this).width() * 0.5;
        $('.brand-statement .content-wrap').css('height', contentHeight);
        $('.brand-name .content-wrap').css('height', contentHeight);
        $('.craftsmanship .content-wrap').css('height', contentHeight);
        $('.brand-statement .content-wrap').css('max-height', contentMaxHeight);
        $('.brand-name .content-wrap').css('max-height', contentMaxHeight);
        $('.craftsmanship .content-wrap').css('max-height', contentMaxHeight);
      } else {
        $('.brand-statement .content-wrap').css('height', 'auto');
        $('.brand-name .content-wrap').css('height', 'auto');
        $('.craftsmanship .content-wrap').css('height', 'auto');
        $('.brand-statement .content-wrap').css('max-height', '100%');
        $('.brand-name .content-wrap').css('max-height', '100%');
        $('.craftsmanship .content-wrap').css('max-height', '100%');
      }
    }
  });
  
  // about-top パララックス処理
  $(window).on('load resize scroll', function(){
    if ($('#about-top').length){
      var wh = $(window).height();
      var scrollTop = $(window).scrollTop();
      var current = scrollTop + wh;
      
      /*var kvHeight = $('.key-visual').height();
      var value = 'translateY(' + Math.floor(scrollTop / 3) + 'px)';
      if (scrollTop < kvHeight) {
        $('.key-visual').css('transform', value);
      }*/
      
      $('.content-wrap .background-image').each(function(){
        var targetTop = $(this).offset().top;
        var targetHeight = $(this).height();
        var targetWidth = $(this).width();
        var startPosition = targetTop;
        var endPosition = startPosition + targetHeight + wh;
        //var bgSizeRatio = 1.55;
        var bgSizeRatio = 2;
        var bgMargin = Math.floor(targetHeight * (bgSizeRatio - (targetHeight / targetWidth)));

        var bgPositionY = -(bgMargin) + Math.floor(bgMargin * (current - targetTop) / (targetHeight + wh));
        var bgPosition = 'center ' + bgPositionY + 'px';
        if ((startPosition < current) && (current < endPosition)) {
          $(this).css('background-position', bgPosition);
        }
      });
      $('.content-wrap .background-image-muse').each(function(){
        var targetTop = $(this).offset().top;
        var targetHeight = $(this).height();
        var targetStart = targetTop;
        var targetEnd = targetTop + targetHeight + wh;
        var base = 0;
        if (bp < $(window).width()) {
          base = 200;
        }else{
          base = 50;
        }

        var bgpy = -(base) + Math.floor(base * (current - targetTop) / (targetHeight + wh));
        var bgp = 'center ' + bgpy + 'px';
        if ((targetStart < current) && (current < targetEnd)) {
          $(this).css('background-position', bgp);
        } else {
          $(this).css('background-position', 'center');
        }
      });
    }
  });
  
  
  $(function () {
    
    // 動画高さ指定
    $('.movie-thumbnail').on('click', function() {
      setTimeout(function(){
        //$('.movie__youtube').css('height', '');
        movieHeightSetting();
      }, 400);
    });
    
    
    // アコーディオン
    $('.acd-btn').on("click", function () {
      $('.acd-box').slideToggle(1000);
      $('.acd-btn').toggleClass("active"); //追加部分
    });
    // 動画バナークリック
   $('.movie-thumbnail').on('click', function() {
      $('.modal-content').fadeIn();
      movieHeightSetting();
    });
    // モーダル（動画）背景クリック
   $('.modal-content').on('click', function() {
      $('.modal-content').fadeOut();
    });
    
    
    // about-content ページ専用 //
    if ($('#about-content').length){
      // オープニング処理 //
      setTimeout(function(){
        $('.copy.onload').addClass('onload-active');
      },400);
      setTimeout(function(){
        $('.title.onload').addClass('onload-active');
        $('.text-wrap.onload').addClass('onload-active');
      },1800);
    }
    
    
    // about-top ページ専用 //
    if ($('#about-top').length){
      
      // オープニング処理 //
      // setTimeout(function(){
      //   $('.opening .logo').fadeIn();
      // },400);
      // setTimeout(function(){
      //   $('.opening .logo').fadeOut();
      // },2400);
      // setTimeout(function(){
      //   $('.opening .copy').fadeIn();
        
      //   var $message = $('.opening .copy');
      //   var $wordList = $('.opening .copy').html().split("");
      //   $('.opening .copy').html("");
      //   $.each($wordList, function(idx, elem) {
      //       var newEL = $("<span/>").text(elem).css({ opacity: 0 });
      //       newEL.appendTo($message);
      //       newEL.delay(idx * 80);
      //       newEL.animate({ opacity: 1 }, 1100);
      //   });
      // },3400);
      // setTimeout(function(){
      //   $('.opening').fadeOut();
      // },7400);
      // $('.opening').on('click', function() {
      //   $('.opening').fadeOut();
      // });
      
      // CRUCIAL VALUES FOR THE BRAND スライド //
      $('.crucial-values__list').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '180px',
        focusOnSelect: false,
        speed: 1000,
        slidesToShow: 1,
        
        responsive: [
          {
            breakpoint: 736,
            settings: {
              centerMode: false,
              centerPadding: '0px',
            },
          },
        ],
      });
    }
  });
  
  
  // 動画高さ指定
  function movieHeightSetting(){
    var movieWidth = $('.movie__youtube').width();
    var movieHeight = movieWidth * 0.5625;
    //var movieMarginTop = ($(window).height() - movieHeight) / 2;
    $('.movie__youtube').css('height', movieHeight);
    //$('.movie__youtube').css('margin-top', movieMarginTop);
  }


}(jQuery, window));
  
